import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { OrderModel } from '../models/OrdersViewModel';
import OrderInfo from './order-info';

let icons = {
    topup: "phone_android",
    nauta: "email",
    ais: "payment",
    banking: "account_balance",
    cash: "attach_money",
    delivery: "shopping_basket"
};

@Component({
    name: 'order-component',
    template: '#order-component',
    components: { OrderInfo }
})
export default class Order extends Vue {
    // local variable
    expandIndex: number = -1;

    isDownloading: boolean = false;

    isCreditNoteDownloading: boolean = false;


    // props
    @Prop({})
    order: OrderModel;

    @Prop({})
    index: number;

    @Prop({})
    getInvoiceUrl: string;

    @Prop({})
    getCreditNoteUrl: string;

    @Prop({})
    pageIndex: number;

    @Prop({})
    resendOrderUrl: string;

    @Prop({})
    itemsOnPage: number;

    get orderInfoClass() {
        let currentOrdersCount = this.pageIndex * this.itemsOnPage;
        let currentOrderIndex = this.index + currentOrdersCount;

        return 'id-' + currentOrderIndex;
    }


    //computed fields
    get productIcon(): string {
        return this.getIconsBySku(this.order);
    }

    get IsDisplayAdditionalInfo() {
        return this.expandIndex === this.index;
    }

    get GetOrderClasses(): string {
        var orderClasses = "";

        if (this.expandIndex === this.index)
            orderClasses += "expanded ";

        if (this.index % 2 == 1)
            orderClasses += "odd ";

        if (this.index % 2 == 0)
            orderClasses += "even ";

        return orderClasses;
    }

    // methods
    changeExpandIndex() {
        this.expandIndex = (this.expandIndex == this.index) ? -1 : this.index;
    }

    getIconsBySku(sku: any): string {
        if (sku.ProductSku == null)
            return "shopping_cart";

        if (sku.ProductSku.includes("ais"))
            return icons.ais;
        if (sku.ProductSku.includes("cash"))
            return icons.cash;
        if (sku.ProductSku.includes("nauta"))
            return icons.nauta;
        if (sku.ProductSku.includes("topup"))
            return icons.topup;
        if (sku.ProductSku.includes("banking"))
            return icons.banking;
        if (sku.ProductSku.includes("delivery")) {
            if (sku.CategoryName == "Pharmacy")
                return "pharmacy";
            if (sku.CategoryName == "Food Combos") {
                return "food"
            }
            if (sku.CategoryName == "Mixed Bundles") {
                return "shopping_cart"
            }
            if (sku.CategoryName == "Personal Hygiene Bundles") {
                return "personal"
            }
            return "shopping_cart"
        }
        return "shopping_cart"
        
    };

    resendOrder(event: Event): void {
        const url = this.resendOrderUrl;
        const orderId = this.order.OrderId;

        const verificationToken = document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement;
        const formData = new FormData();
        formData.append('__RequestVerificationToken', verificationToken.value);
        formData.append("OrderId", orderId.toString());
        const data = new URLSearchParams(formData as any);

        fetch(url, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => response.text())
            .then(data => {
                window.location.href = data;
            });
    };

    getInvoice(event: Event): void{
        this.isDownloading = true;
        let url = this.getInvoiceUrl;
        let orderGuid = this.order.OrderGuid;

        this.getDocument(url, orderGuid);
    };

    getCreditNote(event: Event): void {
        this.isCreditNoteDownloading = true;
        let url = this.getCreditNoteUrl;
        let orderGuid = this.order.OrderGuid;

        this.getDocument(url, orderGuid);
    };


    getDocument(url: string, orderGuid: string): void {
        fetch(`${url}?orderGuid=${orderGuid}`, {
            method: 'GET',
        })
            .then(async (response) => {
                if (response.ok) {
                    const fileName = response.headers.get('content-disposition')?.split("filename*=UTF-8''")[1];
                    let blob = await response.blob();
                    return ({
                        blob,
                        fileName,
                        contentType: response.headers.get('content-type')
                    });
                }
                alert("The document can not be downloaded");
                throw new Error('Network response was not ok');
            })
            .then(({ blob, fileName, contentType }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([blob], { type: contentType }));

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', fileName); //any other extension

                document.body.appendChild(link);
                link.click();
                link.remove();
                this.isDownloading = false;
                this.isCreditNoteDownloading = false;
            })
            .catch((error) => {
                this.isDownloading = false;
                this.isCreditNoteDownloading = false;
                console.error('There has been a problem with your fetch operation: ', error);
            });
    }
}